// Shared Partytown constants + helpers.
//
// Partytown relocates resource-intensive third-party scripts (here: Meta's
// fbevents.js) off the main thread into a web worker. Scripts tagged with
// `type="text/partytown"` are picked up by the Partytown runtime; the
// `ptupdate` event asks it to re-scan the DOM for scripts injected after boot.

export const PARTYTOWN_SCRIPT_TYPE = 'text/partytown'

export const PARTYTOWN_UPDATE_EVENT = 'ptupdate'

// Partytown's service worker. The loader registers it itself, but we also
// pre-register it from an inline script in _document <head> so that on cold
// first visits the SW is active well before the loader creates the sandbox
// iframe. `partytown-sandbox-sw.html` is a VIRTUAL url synthesized by this
// SW's fetch handler — if the iframe request races SW activation and reaches
// the network it 404s and the sandbox never boots (silent pixel loss).
export const PARTYTOWN_SW_URL = '/~partytown/partytown-sw.js'
export const PARTYTOWN_SW_SCOPE = '/~partytown/'

// How long Partytown waits for the sandbox before giving up and replaying
// `text/partytown` scripts on the main thread (default 10s). Lowered so a
// document can't sit eventless for 10s. NOTE: that built-in fallback only
// replays scripts present at DOMContentLoaded — FbPixel's bootstrap is
// injected later, so FbPixel runs its own watchdog sequenced AFTER this
// timeout (see PARTYTOWN_PIXEL_WATCHDOG_MS in FbPixel.ts).
export const PARTYTOWN_FALLBACK_TIMEOUT_MS = 5000

/**
 * Coerces the Partytown experiment treatment membership (from `pageProps.isPartytownEnabled`,
 * resolved per user by the `all__fb-pixel_partytown-offload__web` experiment) to a strict boolean.
 * Only an explicit `true` (treatment bucket) opts a request into the worker path.
 */
export function isPartytownEnabled(enabled: boolean | null | undefined): boolean {
  return enabled === true
}

/**
 * Tells the Partytown runtime to re-scan the DOM for `text/partytown` scripts.
 * Required after injecting such a script post-boot (Partytown only scans at
 * startup otherwise). No-op on the server.
 */
export function dispatchPartytownUpdate(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(PARTYTOWN_UPDATE_EVENT))
}
